<template>
    <gofix-card :title="section" fullContent class="gofixCardChecklist mb-0" classHeader="pl-25" collapse>
        <div class="gofixBasicTable">
            <div class="dataList">
                <b-table :tbody-tr-class="rowClass" :fields="fields" :responsive="true" :items="item.safety_checklist_entries" fixed class="mb-0">
                    <template slot="input" slot-scope="row">
                        {{ row.item.input.data_type ? row.item.input.data_type : '-' }}
                    </template>
                    <template slot="value" slot-scope="row">
                        <template v-if="row.item.status != 'NA'">
                            <b-form-checkbox @input="getCheckListEntryValue(row.item)" v-if="!row.item.input.data_type || row.item.input.data_type === 'Checkbox'" :disabled="!isAllowEditEntryValue" v-model="row.item.input.value"></b-form-checkbox>
                            <gofix-form-input @change="getCheckListEntryValue(row.item)" class="m-0" label v-if="row.item.input.data_type === 'Free text'" :disabled="!isAllowEditEntryValue" v-model="row.item.input.value"></gofix-form-input>
                            <div class="d-flex align-items-center" v-if="row.item.input.data_type === 'Reading'">
                                <gofix-form-input-number 
                                @change="checkReadingTypeValidate(row.item)"
                                @input="resetCheckReadingTypeValidate(row.item)"
                                @focus="handleFocus(arguments[0], row.item)"
                                label class="m-0"
                                :includeThousandsSeparator="false"
                                allowNegative
                                :class="{ 'form-input--error': row.item.status === 'Filled' && !row.item.input.value }"
                                :disabled="!isAllowEditEntryValue"
                                v-model="row.item.input.value"></gofix-form-input-number>
                                <span class="ml-1 d-block nowrap" v-if="row.item.input.unit">{{row.item.input.unit}}</span>
                            </div>
                            <gofix-form-dropdown @input="getCheckListEntryValue(row.item)" class="m-0" label v-if="row.item.input.data_type === 'Dropdown'" :disabled="!isAllowEditEntryValue" v-model="row.item.input.value" :options="row.item.input.possible_value"
                            >
                                <template slot="gofixInput:dropdown:option" slot-scope="option">
                                    <span v-b-tooltip.hover.top :title="option.label" v-html="option.label"></span>
                                </template>
                            </gofix-form-dropdown>
                        </template>
                        <template v-else>
                            <span class="na-status">--</span>
                        </template>
                    </template>
                    <template slot="status" slot-scope="row">
                        <gofix-form-dropdown 
                            :clearable="false" class="m-0" 
                            label 
                            @change="changeChecklistEntryStatus(row.item)" 
                            v-model="row.item.status" 
                            :disabled="!isAllowEditEntryStatus"
                            :options="checkListEntryStatus">
                        </gofix-form-dropdown>
                    </template>
                    <template slot="safety_remark_id" slot-scope="row">
                        <div class="checklist-remark-box justify-content-between">
                            <div @click="editFollowUp(row.item)" class="checklist-remark-box-item d-flex">
                                <b-form-checkbox class="job-list-checkbox" disabled :checked="Number(row.item.safety_remark_id) > 0 ? true : false"></b-form-checkbox>
                                <span class="d-inline pl-13">{{row.item.safety_remark ? row.item.safety_remark.description:''}}</span>
                            </div>
                            <div v-if="row.item.safety_remark && row.item.safety_remark.attachments" class="photosThumb checklist-remark-box-item mt-0 mb-0">
                                <viewer-image :images="row.item.safety_remark.attachments">
                                    <template slot="gofixViewer:list_image" ref="viewerFinding" slot-scope="{images}">
                                        <ul class="list-thumb">
                                            <template v-for="(item,key) in row.item.safety_remark.attachments">
                                                <li v-if="key < 2" v-bind:key="key">
                                                    <img v-auth-image="item.url.medium" alt  src="img/loading.gif"/>
                                                </li>
                                                <li v-if="key >= 2 && key <= (images.length-2)" v-bind:key="key" class="d-none">
                                                    <img v-auth-image="item.url.medium" alt  src="img/loading.gif"/>
                                                </li>
                                                <template v-if="key == 2 && images.length > 2">
                                                    <div class="attachmentsColumn pl-0" :key="key">
                                                        <div class="item-content bg-transparent pd-0">
                                                            <img class="image-viewer" v-auth-image="images[images.length-1].url.original"  src="img/loading.gif">
                                                            <span class="checklist-photo-custom checklist-remark-box-item pd-0">{{ '+' + (images.length - 2) }}</span>
                                                        </div>
                                                    </div>
                                                </template>
                                            </template>
                                        </ul>
                                    </template>
                                </viewer-image>
                            </div>
                        </div>
                    </template>
                </b-table>
            </div>
        </div>
    </gofix-card>
</template>

<script>
const ViewImg = () => import("../plugins/ViewImg.vue")
const ViewerImage = () => import('../plugins/ViewerImage.vue')
    export default {
        name: 'checklist-entry-item',
        components: {
            ViewerImage,
            ViewImg,
        },
        props: {
            item: {
                type: Object,
                default: () => {}
            },
            section: {
                type: String,
                default: null
            },
            job: {
                type: Object,
                default: () => {}
            }
        },
        data() {
            return{
                fields: [
                    {
                        key: 'sequence',
                        label: 'Number',
                        thStyle: 'width: 132px',
                        thClass: 'pl-25',
                        tdClass: 'pl-25',
                    },
                    {
                        key: 'name',
                        label: 'Service Description',
                        thStyle: 'width: 240px'
                    },
                    {
                        key: 'input',
                        label: 'Value Type',
                        thStyle: 'width: 150px'
                    },
                    {
                        key: 'value',
                        label: 'Value',
                        thStyle: 'width: 150px'
                    },
                    {
                        key: 'status',
                        label: 'Status',
                        thStyle: 'width: 150px'
                    },
                    {
                        key: 'safety_remark_id',
                        label: 'Remarks',
                        thStyle: 'width: 175px',
                    },
                    // {
                    //     key: 'follow_up',
                    //     label: 'Follow Up',
                    //     thStyle: 'width: 150px',
                    //     thClass: 'text-center',
                    //     tdClass: 'text-center'
                    // }
                ],
                checkListEntryStatus:[
                    'Filled',
                    'Unfilled',
                    'NA'
                ],
                checkListEntryUpdate:[],
                loading:false,
                timer: {
                    issue: null
                }
            }
        },
        computed: {
            isAllowEditEntryRemark() {
                return this.isAllowEdit;
            },
            isAllowEditEntryStatus() {
                return this.isAllowEdit;
            },
            isAllowEditEntryValue() {
                return this.isAllowEdit;
            },
            isAllowEdit() {
                if(this.job) {
                    if(this.job.type == 'Safety Inspection Checklist') {
                        if(this.job.status != 'New') return false;
                    }
                    if(['WAH', 'Lifting Operations', 'Hot Works'].includes(this.job.type)) {
                        if((this.job.related_id == null && this.job.status == 'New') || (
                            (this.job.related_id != null && (this.job.status != 'New' && this.job.status != 'Approved')) && (this.job.planned_date && new Date(this.job.planned_date).toDateString() === new Date().toDateString())
                        )) return false;
                    }
                }
                return true
            }   
        },
        created() {},
        methods: {
            rowClass(item, type){
                if(item && item.hasOwnProperty('is_output_highlighted') && item.is_output_highlighted == true){
                    if(item.input && item.input.data_type && item.input.data_type === "Reading" && item.is_output_highlighted){
                        return 'row-outside-value';
                    }
                }
                return;
            },
            handleFocus (value, item) {
                item.value_old = value;
                item.output_old = item.output;
                item.is_output_highlighted_old = item.is_output_highlighted;
                this.$emit('inputType', true)
            },
            resetCheckReadingTypeValidate(item) {
                if(item.hasOwnProperty('is_check_threshold') && item.is_check_threshold) item.is_check_threshold = false
            },
            async getCheckListEntryValue(val){
                this.$emit('updateCheckListEntries', { val:val, from_status:false});
            },
            async editFollowUp(checklistEntry){
                if(!this.isAllowEditEntryRemark) return;
                this.$emit('selectChecklistEntry', checklistEntry)
            },
            async checkReadingTypeValidate(item){
                let result = await this.getMinMax(item);
                
                if(result.is_output_highlighted){
                    await this.$bvModal.msgBoxConfirm('Your value exceeds the threshold. Are you sure to keep the record?', {
                        title: 'Warning!',
                        size: 'sm',
                        buttonSize: 'sm',
                        okVariant: 'primary',
                        okTitle: 'OK',
                        cancelTitle: 'CANCEL',
                        headerClass: 'p-2 border-bottom-0',
                        footerClass: 'p-2 border-top-0',
                        centered: true,
                        id: "msgConfirm"
                    })
                    .then(value => {
                        if(value){
                            item.input.value = parseFloat(item.input.value);
                            item.is_output_highlighted = result.is_output_highlighted;
                            item.output = result.output;
                        } else{
                            item.input.value = item.value_old ? item.value_old : null;
                            item.is_output_highlighted = item.is_output_highlighted_old;
                            item.output = item.output_old;
                        }
                    })
                } else {
                    item.is_output_highlighted = result.is_output_highlighted;
                    item.output = result.output;
                }
                this.getCheckListEntryValue(item);
            },
            async getMinMax(item) {
                let data = {};
                await this.$store.dispatch("SafetyAppController/getCheckListCalculated", {
                    id: item.id,
                    data: {
                        input: item.input
                    },
                }).then(result => {
                    data = Object.assign(data, result);
                });
                return data;
            },
            async changeChecklistEntryStatus(item){
                switch (item.status) {
                    case 'Filled':
                        if(!item.input.value){
                            if(item.input.data_type === 'Checkbox'){
                                item.input.value = true;
                            } 
                            else{
                                this.$alertNotification('Please enter checklist entries value when the status Filled!','danger');
                            }
                        }
                        break;
                    case 'Unfilled':
                        item.input.value = null;
                        break;
                    case 'NA':
                        item.input.value = null;
                        break;
                }
                this.$emit('updateCheckListEntries',{val:item,from_status:true});
            },
        }
    }
</script>
